<template>
  <form name="form">
    <b-modal id="ProducerChangeName" hide-footer size="xl">
      <template #modal-title> Zmiana nazwy dostawcy </template>


      <div class="row">
        <div class="col">
          <label for="ProducerName" class="form-label">Nazwa Dostawcy</label>
          <input
            type="text"
            class="form-control"
            id="ProducerName"
            v-model="producer.name"
          />
        </div>
      </div>

      <div class="col align-self-end div-form-buttons-area">
        <button class="btn btn-primary" type="button" @click="SaveData">
          Zapisz
        </button>
        <button
          class="btn btn-warning"
          type="button"
          @click="ClearFormAndCloseWindow"
        >
          Zamknij
        </button>
      </div>
    </b-modal>
  </form>
</template>

<script>
import axios from "axios";
import urlConfig from "../../../../mixins/url";

export default {
  components: {},
  mixins: [urlConfig],
  props: ["producer"],
  data() {
    return {
      form: {
        id: 0,
        name: "",
      },
      formErrors: [],
    };
  },
  methods: {
    ClearFormAndCloseWindow() {
      this.$bvModal.hide("ProducerChangeName");
      this.form = {
        id: 0,
        name: "",
      };
      this.formErrors = [];
    },
    SaveData() {
      this.formErrors = [];
      this.form.id = this.producer.id;
      this.form.name = this.producer.name;

      this.ValidateForm();
      if (this.formErrors.length == 0) {
        var url = this.url.serverUrl + this.url.Producer.ChangeName;
        var that = this;
        axios
          .post(url, this.form)
          .then(function () {
            that.$emit("ProducerChangeName", that.form);
            that.ClearFormAndCloseWindow();
          })
          .catch(function (e) {
            console.log(e);
          });
      }
    },
    ValidateForm() {
      if (!this.form.name) {
        this.formErrors.push("nameError");
      }
    },
  },
};
</script>